import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { orgInfoFn as _orgInfoFn, getDepList, delFn, saveDepSort } from 'api/org/dep';
// 设置公司信息
import setDialog from './modal/set-dialog';
import subDepDialog from './modal/sub-dep-dialog';

// 引入icon
var icons = [require('@/assets/img/orgleave1.png'), require('@/assets/img/orgleave2.png'), require('@/assets/img/orgleave3.png'), require('@/assets/img/orgleave4.png')];
export default {
  components: {
    setDialog: setDialog,
    subDepDialog: subDepDialog
  },
  data: function data() {
    return {
      // 公司设置弹窗
      isSetDialog: false,
      // 新建子部门弹窗
      isSubDep: false,
      // 公司信息
      companyInfo: {},
      // 部门table列表
      tableData: [],
      // 在职状态
      state: true,
      // 表格loading
      loading: false,
      // 图表展示
      icons: icons,
      save: function save() {}
    };
  },
  created: function created() {
    var _this = this;
    this.init();
    // 函数节流 排序保存 间隔1s
    this.save = this.$util.throttle(function () {
      saveDepSort({
        depts: _this.tableData
      });
    }, 1000);
  },
  methods: {
    init: function init() {
      this.orgInfoFn();
    },
    // 设置
    setHandle: function setHandle(obj) {
      var _this2 = this;
      this.isSetDialog = true;
      this.$nextTick(function () {
        return _this2.$refs.setDialog.init(obj.department_id ? obj : _this2.companyInfo);
      });
    },
    // 新建子部门
    subDepHandle: function subDepHandle(obj, state) {
      var _this3 = this;
      this.state = state;
      this.isSubDep = true;
      this.$nextTick(function () {
        return _this3.$refs.subDepDialog.init(obj.department_id ? obj : _this3.companyInfo);
      });
    },
    // 获取公司信息
    orgInfoFn: function orgInfoFn() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _orgInfoFn();
            case 2:
              res = _context.sent;
              _this4.companyInfo = res.data;
              _this4.depListFn();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 获取部门列表
    depListFn: function depListFn() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this5.tableData = [];
              _this5.loading = true;
              _context2.next = 4;
              return getDepList({
                department_id: _this5.companyInfo.id
              });
            case 4:
              res = _context2.sent;
              _this5.tableData = res.data._child || [];
              _this5.loading = false;
              _this5.openData();
              _this5.$nextTick(function () {
                _this5.addEv();
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 编辑 删除 新增
    handlerClick: function handlerClick(params) {
      var _this6 = this;
      var status = params.status,
        row = params.row;
      // 新建子部门
      if (status === 1) {
        var rows = _objectSpread(_objectSpread({}, row), {}, {
          id: row.department_id
        });
        this.subDepHandle(rows, false);
      }
      // 编辑部门
      if (status === 2) this.setHandle(row);
      // 删除部门
      if (status === 3) {
        this.$confirm(this.$t('35'), this.$t('229'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        }).then(function () {
          delFn({
            department_id: row.department_id
          }).then(function (res) {
            if (res && res.code === 1) {
              _this6.depListFn();
              _this6.$message.success(res.message);
            }
          });
        });
      }
    },
    // 添加事件
    addEv: function addEv() {
      var _this7 = this;
      var rows = document.querySelectorAll('.sortAble .el-table__row');
      rows.forEach(function (item, index) {
        // 添加可拖拽
        item.setAttribute('draggable', 'true');
        item.addEventListener('dragstart', function (event) {
          return event.dataTransfer.setData('Text', JSON.stringify(_this7.changeData[index]));
        });
        // 清除浏览器默认行为
        item.addEventListener('dragover', function (event) {
          return event.preventDefault();
        });
        // 目标接收拖拽对象
        item.addEventListener('drop', function (e) {
          e.preventDefault();
          var data = JSON.parse(e.dataTransfer.getData('Text'));
          var currentData = _this7.changeData[index];
          if (data.ancestry_id !== currentData.ancestry_id) return false;
          // 获取下标
          var mIndex = _this7.getIndex(currentData);
          var cIndex = _this7.getIndex(data);
          var parent = mIndex.data;
          var state = mIndex.index < cIndex.index;
          // 根据状态换位
          parent._child.splice(mIndex.index + (state ? 0 : 1), 0, data);
          parent._child.splice(cIndex.index + (state ? 1 : 0), 1);
          // 数据响应
          _this7.changeTableData(parent);
        });
      });
    },
    // 数据展开
    openData: function openData() {
      var dep = function dep(arr) {
        return arr.map(function (item) {
          var child = item._child ? dep(item._child) : false;
          return child ? [item].concat(_toConsumableArray(child)) : item;
        });
      };
      this.changeData = dep(this.tableData || []).flat(Infinity);
    },
    // 遍历获取下标
    getIndex: function getIndex(params) {
      // 一级菜单
      var index = false;
      if (params.ancestry_id === '1') {
        this.tableData.forEach(function (item, i) {
          if (item.department_id === params.department_id) index = i;
        });
        return {
          data: {
            _child: this.tableData
          },
          index: index
        };
      }
      // 不限层级 获取下标
      var dep = function dep(arr) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        arr.forEach(function (item) {
          if (item.department_id === params.ancestry_id) data = item;
        });
        return data;
      };
      var current = dep(this.changeData);
      current._child.forEach(function (item, i) {
        if (item.department_id === params.department_id) index = i;
      });
      return {
        data: current,
        index: index
      };
    },
    // 改变tableData 数据响应
    changeTableData: function changeTableData(params) {
      var _this8 = this;
      var dep = function dep(arr) {
        arr.forEach(function (item, index) {
          if (params.department_id === item.department_id) {
            _this8.$set(arr, index, params);
            return false;
          }
          if (item._child) dep(item._child);
        });
      };
      dep(this.tableData);
      this.save();
    }
  }
};